// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebase : {
    apiKey: "AIzaSyCmOkWVWji1rxPeZK34vIIkjPd4mBDafyU",
    authDomain: "fcx-community.firebaseapp.com",
    projectId: "fcx-community",
    storageBucket: "fcx-community.appspot.com",
    messagingSenderId: "1066399988995",
    appId: "1:1066399988995:web:82ce3adc8cda339bdd7d36"
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
